import { render, staticRenderFns } from "./RptPayments.vue?vue&type=template&id=c48faeea&scoped=true&"
import script from "./RptPayments.vue?vue&type=script&lang=js&"
export * from "./RptPayments.vue?vue&type=script&lang=js&"
import style0 from "./RptPayments.vue?vue&type=style&index=0&id=c48faeea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48faeea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDataTable,VRow,VTextField})
